import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { loginSuccess, loginUnload, loadApp } from '../../actions';

import { Link } from 'react-router-dom';
import queryString from 'query-string';
import LoginForm from './LoginForm';

const mapStateToProps = state => ({ ...state.login });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({loginSuccess, loadApp, onUnload: loginUnload}, dispatch);
};


class Login extends Component {
  
  constructor (props){
    super(props);
    
    this.onSuccess = this.onSuccess.bind(this);
    this.onFail = this.onFail.bind(this);
    
    const { next } = queryString.parse(props.location.search) || {};
    this.state = {next};
  }
  
  onSuccess (user) {
    const { loginSuccess, loadApp } = this.props;
    const { next } = this.state;
    
    loginSuccess({...user, next});
    loadApp(user);
  }
  
  onFail (error){
    
  }
  
  render () {
    const { initialValues } = this.props;
    const { next } = this.state;
    
    return (
      <div className="panel">
        <div className="panel-body">
          <h3 className="text-center">Welcome back!</h3>
          <LoginForm {...{initialValues, onSuccess: this.onSuccess, onFail: this.onFail}} />
        </div>
        <div className="panel-footer text-center">
          <Link to={`/signup?next=${next || '/'}`}>Don&apos;t have an account? Sign up &rarr;</Link>
        </div>
      </div>
    )
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/auth/Login.js